import API from '../AxiosInstance';

export default {
  getDownloadProgress: function() {
    return API.get('download/progress');
  },
}
